import { Emitter } from './emitter';
import { Beech_audio } from './beech_audio';
import { Config } from './config';
import Flow from './flow';
import Foreman from './foreman';
import Logger from './logger';
import { Model } from './model';
import BeechNotify from './notify';
import { Persist } from './persist';
import Server from './server';
import Setup from './setup';
import BeechTwilio from './beech_twilio';
import Metrics from './metrics';
import { Util } from './util';
import Embedded from './embedded';
import AutoAway from './auto-away';
import './fontawesome';

declare global {
	let beech: Beech;
}

export class Beech extends Emitter {
	audio: Beech_audio;
	config: Config;
	logger: Logger;
	model: Model;
	persist: Persist;
	server: Server;
	twilio: BeechTwilio;
	foreman: Foreman;
	setup: Setup;
	notify: BeechNotify;
	flow: Flow;
	metrics: Metrics;
	util: Util;
	embedded: Embedded;
	autoAway: AutoAway;
	lastDialed: string;

	public constructor() {
		super();

		this.lastDialed = '';

		logg.info('beech >> init');

		this.config = JSON.parse((<any>document.getElementById('gpsh-app-root')).getAttribute('config'));

		this.logger = new Logger(this);
		this.util = new Util(this);
		this.audio = new Beech_audio();
		this.flow = new Flow(this);
		this.foreman = new Foreman(this);
		this.model = new Model(this);
		this.notify = new BeechNotify(this);
		this.persist = new Persist(this);
		this.model.setAlertViewVisible(this.persist.getAlertViewActive());
		this.server = new Server(this);
		this.setup = new Setup(this);
		this.metrics = new Metrics(this);
		this.twilio = new BeechTwilio(this);
		this.embedded = new Embedded(this);
		this.autoAway = new AutoAway(this);
		this.autoAway.start();
		this.wireAutoUpdate();

		logg.info('beech >> ready');

		this.emit('ready', {});
	}

	private wireAutoUpdate(): void {
		const api = window.electronAPI;
		if (!api || typeof api.onUpdateAvailable !== 'function') return;
		api.onUpdateAvailable(() => this.model.setUpdateAvailable(true));
		// If the download finished before this renderer (re)loaded we missed the
		// live event — reconcile from the main process on boot.
		api.isUpdateReady?.().then((ready) => {
			if (ready) this.model.setUpdateAvailable(true);
		});
	}

	public setLastDialed(number: string): void {
		this.lastDialed = number;
		this.persist.setLastDialed(number);
	}

	public getLastDialed(): string {
		return this.lastDialed;
	}
}
